module.exports = __webpack_public_path__ + "img/417-75f424.png";